// // src/pages/Dashboard/ContactPersonBalance/components/ContactPersonBalanceTable.jsx
// import React, { useState, useEffect } from 'react';
// import styles from './ContactPersonBalanceTable.module.css';
// import * as XLSX from 'xlsx';
// import { contactPersonBalanceApi } from '../../../../api/contactpersonbalance/contactPersonBalanceApi';

// const ContactPersonBalanceTable = () => {
//   const [allBalances, setAllBalances] = useState([]);
//   const [filteredBalances, setFilteredBalances] = useState([]);
//   const [displayBalances, setDisplayBalances] = useState([]);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedAging, setSelectedAging] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const itemsPerPage = 20;

//   const agingFilters = [
//     { label: 'All', value: '' },
//     { label: '0-30 Days', value: '0-30' },
//     { label: '31-60 Days', value: '31-60' },
//     { label: '61-90 Days', value: '61-90' },
//     { label: '90+ Days', value: '90+' }
//   ];

//   useEffect(() => {
//     fetchAllBalances();
//   }, []);

//   useEffect(() => {
//     applyFiltersAndPagination();
//   }, [allBalances, searchTerm, selectedAging, currentPage]);

//   const fetchAllBalances = async () => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       console.log('🔍 Fetching ALL contact person balances...');
      
//       const data = await contactPersonBalanceApi.exportBalances('');
      
//       console.log('✅ All data received:', data.length, 'records');
      
//       if (data && Array.isArray(data)) {
//         setAllBalances(data);
//         setCurrentPage(0);
//       } else {
//         console.error('❌ Invalid data structure:', data);
//         setAllBalances([]);
//         setError('Invalid data received from server');
//       }
//     } catch (err) {
//       setError('Failed to load balances');
//       console.error('❌ Error fetching balances:', err);
//       setAllBalances([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const applyFiltersAndPagination = () => {
//     let filtered = [...allBalances];

//     if (searchTerm && searchTerm.trim() !== '') {
//       const searchLower = searchTerm.toLowerCase();
//       filtered = filtered.filter(balance => 
//         balance.invoiceNo?.toString().toLowerCase().includes(searchLower) ||
//         balance.soNumber?.toString().toLowerCase().includes(searchLower) ||
//         balance.customerName?.toLowerCase().includes(searchLower) ||
//         balance.contactPerson?.toLowerCase().includes(searchLower) ||
//         balance.soCustomerRefNo?.toLowerCase().includes(searchLower) ||
//         balance.country?.toLowerCase().includes(searchLower) ||
//         balance.state?.toLowerCase().includes(searchLower) ||
//         balance.trackingNo?.toLowerCase().includes(searchLower) ||
//         balance.paymentTerms?.toLowerCase().includes(searchLower) ||
//         balance.salesPerson?.toLowerCase().includes(searchLower) ||
//         balance.masterSalePerson?.toLowerCase().includes(searchLower) ||
//         balance.balanceDue?.toString().includes(searchLower) ||
//         balance.overdueDays?.toString().includes(searchLower)
//       );
//     }

//     if (selectedAging) {
//       filtered = filterByAging(filtered, selectedAging);
//     }

//     setFilteredBalances(filtered);

//     const total = Math.ceil(filtered.length / itemsPerPage);
//     setTotalPages(total);

//     const startIndex = currentPage * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     const pageRecords = filtered.slice(startIndex, endIndex);
    
//     setDisplayBalances(pageRecords);

//     console.log('📊 Filtered:', filtered.length, 'records');
//     console.log('📄 Page', currentPage + 1, ':', pageRecords.length, 'records');
//   };

//   const filterByAging = (data, aging) => {
//     switch (aging) {
//       case '0-30':
//         return data.filter(b => b.overdueDays >= 0 && b.overdueDays <= 30);
//       case '31-60':
//         return data.filter(b => b.overdueDays >= 31 && b.overdueDays <= 60);
//       case '61-90':
//         return data.filter(b => b.overdueDays >= 61 && b.overdueDays <= 90);
//       case '90+':
//         return data.filter(b => b.overdueDays > 90);
//       default:
//         return data;
//     }
//   };

//   const handleSearch = () => {
//     setCurrentPage(0);
//   };

//   const handleClearFilters = () => {
//     setSearchTerm('');
//     setSelectedAging('');
//     setCurrentPage(0);
//   };

//   const handleClearSearch = () => {
//     setSearchTerm('');
//     setCurrentPage(0);
//   };

//   const handleAgingFilterChange = (value) => {
//     setSelectedAging(value);
//     setCurrentPage(0);
//   };

//   const handleExportExcel = () => {
//     try {
//       const dataToExport = filteredBalances.length > 0 ? filteredBalances : allBalances;
      
//       const worksheet = XLSX.utils.json_to_sheet(dataToExport.map(inv => ({
//         'Invoice No': inv.invoiceNo,
//         'Invoice Date': inv.invoiceDate,
//         'SO#': inv.soNumber,
//         'SO Date': inv.soDate,
//         'Customer Name': inv.customerName,
//         'Contact Person': inv.contactPerson,
//         'SO Customer Ref No': inv.soCustomerRefNo,
//         'Invoice Total': inv.invoiceTotal,
//         'Balance Due': inv.balanceDue,
//         'Country': inv.country,
//         'State': inv.state,
//         'Overdue Days': inv.overdueDays,
//         'Payment Terms': inv.paymentTerms,
//         'Tracking No': inv.trackingNo,
//         'Dispatch Date': inv.dispatchDate,
//         'Sales Person': inv.salesPerson,
//         'Master Sales Person': inv.masterSalePerson,
//         'Payment Status': inv.paymentStatus
//       })));
      
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, 'Contact Person Balances');
//       XLSX.writeFile(workbook, 'contact_person_balances.xlsx');
      
//       console.log('✅ Exported', dataToExport.length, 'records to Excel');
//     } catch (err) {
//       console.error('Error exporting balances:', err);
//       alert('Failed to export data');
//     }
//   };

//   const formatCurrency = (amount) => {
//     return '₹' + (amount || 0).toLocaleString('en-IN');
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-GB', { 
//       day: '2-digit', 
//       month: 'short', 
//       year: 'numeric' 
//     });
//   };

//   const getOverdueBadgeClass = (days) => {
//     if (days === 0) return styles.overdueBadge0;
//     if (days <= 30) return styles.overdueBadge30;
//     return styles.overdueBadge90;
//   };

//   return (
//     <div className={styles.wrapper}>
//       <div className={styles.header}>
//         <h2 className={styles.pageTitle}>My Customer Balances</h2>
//         {!loading && (
//           <div className={styles.recordCount}>
//             {filteredBalances.length === allBalances.length 
//               ? `${allBalances.length} total records`
//               : `${filteredBalances.length} of ${allBalances.length} records`
//             }
//           </div>
//         )}
//       </div>

//       <div className={styles.filtersSection}>
//         <div className={styles.searchRow}>
//           <div className={styles.searchInputWrapper}>
//             <span className={styles.searchIcon}>🔍</span>
//             <input
//               type="text"
//               placeholder="Search by invoice, customer, SO#, tracking number..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
//               className={styles.searchInput}
//             />
//             {searchTerm && (
//               <button onClick={handleClearSearch} className={styles.clearSearchButton} title="Clear search">
//                 ✕
//               </button>
//             )}
//           </div>
//           <button onClick={handleSearch} disabled={loading} className={styles.searchButton}>
//             Search
//           </button>
//         </div>

//         <div className={styles.agingFilterRow}>
//           <span className={styles.agingLabel}>Filter by Overdue Days:</span>
//           <div className={styles.agingButtonGroup}>
//             {agingFilters.map((filter) => (
//               <button
//                 key={filter.value}
//                 className={`${styles.agingButton} ${selectedAging === filter.value ? styles.agingButtonActive : ''}`}
//                 onClick={() => handleAgingFilterChange(filter.value)}
//                 disabled={loading}
//               >
//                 {filter.label}
//               </button>
//             ))}
//           </div>
//         </div>

//         <div className={styles.filterRow}>
//           <div className={styles.dateFilterGroup}></div>
//           <div className={styles.actionButtons}>
//             <button onClick={handleClearFilters} disabled={loading} className={styles.clearButton}>
//               Clear All Filters
//             </button>
//             <button onClick={handleExportExcel} disabled={loading || allBalances.length === 0} className={styles.excelButton}>
//               <span className={styles.excelIcon}>📊</span>
//               Export Excel
//             </button>
//           </div>
//         </div>
//       </div>

//       {(searchTerm || selectedAging) && (
//         <div className={styles.activeFilters}>
//           <span className={styles.activeFiltersLabel}>Active Filters:</span>
//           {searchTerm && (
//             <div className={styles.filterTag}>
//               Search: "{searchTerm}"
//               <button onClick={handleClearSearch} className={styles.removeFilterButton}>✕</button>
//             </div>
//           )}
//           {selectedAging && (
//             <div className={styles.filterTag}>
//               Aging: {agingFilters.find(f => f.value === selectedAging)?.label}
//               <button onClick={() => handleAgingFilterChange('')} className={styles.removeFilterButton}>✕</button>
//             </div>
//           )}
//         </div>
//       )}

//       {error && (
//         <div className={styles.errorMessage}>{error}</div>
//       )}

//       {loading && (
//         <div className={styles.loadingContainer}>
//           <div className={styles.loadingSpinner} />
//           <div className={styles.loadingText}>Loading your balance records...</div>
//         </div>
//       )}

//       {!loading && (
//         <div className={styles.tableContainer}>
//           <div className={styles.tableWrapper}>
//             <table className={styles.table}>
//               <thead>
//                 <tr>
//                   <th className={styles.th}>Invoice No.</th>
//                   <th className={styles.th}>Invoice Date</th>
//                   <th className={styles.th}>SO#</th>
//                   <th className={styles.th}>SO Date</th>
//                   <th className={styles.th}>Customer Name</th>
//                   <th className={styles.th}>Contact Person</th>
//                   <th className={styles.th}>SO Customer Ref No</th>
//                   <th className={styles.th}>Invoice Total</th>
//                   <th className={styles.th}>Balance Due</th>
//                   <th className={styles.th}>Country</th>
//                   <th className={styles.th}>State</th>
//                   <th className={styles.th}>Overdue Days</th>
//                   <th className={styles.th}>Payment Terms</th>
//                   <th className={styles.th}>Tracking No</th>
//                   <th className={styles.th}>Dispatch Date</th>
//                   <th className={styles.th}>Sales Person</th>
//                   <th className={styles.th}>Master Sales Person</th>
//                   <th className={styles.th}>Payment Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {displayBalances.length > 0 ? (
//                   displayBalances.map((balance, index) => (
//                     <tr key={`${balance.invoiceNo}-${balance.soNumber}-${index}`} className={styles.tr}>
//                       <td className={styles.td}>{balance.invoiceNo}</td>
//                       <td className={styles.td}>{formatDate(balance.invoiceDate)}</td>
//                       <td className={styles.td}>{balance.soNumber}</td>
//                       <td className={styles.td}>{formatDate(balance.soDate)}</td>
//                       <td className={styles.td}>{balance.customerName}</td>
//                       <td className={styles.td}>{balance.contactPerson}</td>
//                       <td className={styles.td}>{balance.soCustomerRefNo || 'N/A'}</td>
//                       <td className={styles.td}>{formatCurrency(balance.invoiceTotal)}</td>
//                       <td className={styles.td}>
//                         <span className={`${styles.balanceDue} ${balance.balanceDue > 0 ? styles.balanceDueOverdue : styles.balanceDueNormal}`}>
//                           {formatCurrency(balance.balanceDue)}
//                         </span>
//                       </td>
//                       <td className={styles.td}>{balance.country}</td>
//                       <td className={styles.td}>{balance.state}</td>
//                       <td className={styles.td}>
//                         <span className={`${styles.overdueBadge} ${getOverdueBadgeClass(balance.overdueDays)}`}>
//                           {balance.overdueDays} days
//                         </span>
//                       </td>
//                       <td className={styles.td}>{balance.paymentTerms}</td>
//                       <td className={styles.td}>{balance.trackingNo || 'N/A'}</td>
//                       <td className={styles.td}>{formatDate(balance.dispatchDate)}</td>
//                       <td className={styles.td}>{balance.salesPerson}</td>
//                       <td className={styles.td}>{balance.masterSalePerson || 'N/A'}</td>
//                       <td className={styles.td}>
//                         <span className={`${styles.paymentStatus} ${balance.paymentStatus === 'Received' ? styles.paymentStatusReceived : styles.paymentStatusPending}`}>
//                           {balance.paymentStatus}
//                         </span>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td className={styles.td} colSpan="18" style={{ textAlign: 'center', padding: '40px' }}>
//                       {searchTerm || selectedAging ? 'No records match your filters' : 'No records found'}
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}

//       {!loading && filteredBalances.length > 0 && (
//         <div className={styles.paginationSection}>
//           <div className={styles.paginationInfo}>
//             Showing {currentPage * itemsPerPage + 1} - {Math.min((currentPage + 1) * itemsPerPage, filteredBalances.length)} of {filteredBalances.length} records
//           </div>
//           <div className={styles.paginationControls}>
//             <button
//               onClick={() => setCurrentPage(0)}
//               disabled={currentPage === 0}
//               className={styles.paginationButton}
//             >
//               First
//             </button>
//             <button
//               onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
//               disabled={currentPage === 0}
//               className={styles.paginationButton}
//             >
//               Prev
//             </button>
//             <div className={styles.pageNumber}>{currentPage + 1} / {totalPages}</div>
//             <button
//               onClick={() => setCurrentPage(prev => Math.min(totalPages - 1, prev + 1))}
//               disabled={currentPage === totalPages - 1}
//               className={styles.paginationButton}
//             >
//               Next
//             </button>
//             <button
//               onClick={() => setCurrentPage(totalPages - 1)}
//               disabled={currentPage === totalPages - 1}
//               className={styles.paginationButton}
//             >
//               Last
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ContactPersonBalanceTable;

// src/pages/Dashboard/ContactPersonBalance/components/ContactPersonBalanceTable.jsx
import React, { useState, useEffect } from 'react';
import styles from './ContactPersonBalanceTable.module.css';
import * as XLSX from 'xlsx';
import { contactPersonBalanceApi } from '../../../../api/contactpersonbalance/contactPersonBalanceApi';

const ContactPersonBalanceTable = () => {
  const [allBalances, setAllBalances] = useState([]);
  const [filteredBalances, setFilteredBalances] = useState([]);
  const [displayBalances, setDisplayBalances] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedAging, setSelectedAging] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const itemsPerPage = 20;

  const agingFilters = [
    { label: 'All', value: '' },
    { label: '0-30 Days', value: '0-30' },
    { label: '31-60 Days', value: '31-60' },
    { label: '61-90 Days', value: '61-90' },
    { label: '90+ Days', value: '90+' }
  ];

  useEffect(() => {
    fetchAllBalances();
  }, []);

  useEffect(() => {
    applyFiltersAndPagination();
  }, [allBalances, searchTerm, selectedAging, currentPage]);

  const fetchAllBalances = async () => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('🔍 Fetching ALL contact person balances...');
      
      const data = await contactPersonBalanceApi.exportBalances('');
      
      console.log('✅ All data received:', data.length, 'records');
      
      if (data && Array.isArray(data)) {
        setAllBalances(data);
        setCurrentPage(0);
      } else {
        console.error('❌ Invalid data structure:', data);
        setAllBalances([]);
        setError('Invalid data received from server');
      }
    } catch (err) {
      setError('Failed to load balances');
      console.error('❌ Error fetching balances:', err);
      setAllBalances([]);
    } finally {
      setLoading(false);
    }
  };

  const applyFiltersAndPagination = () => {
    let filtered = [...allBalances];

    if (searchTerm && searchTerm.trim() !== '') {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(balance => 
        balance.invoiceNo?.toString().toLowerCase().includes(searchLower) ||
        balance.soNumber?.toString().toLowerCase().includes(searchLower) ||
        balance.customerName?.toLowerCase().includes(searchLower) ||
        balance.contactPerson?.toLowerCase().includes(searchLower) ||
        balance.soCustomerRefNo?.toLowerCase().includes(searchLower) ||
        balance.country?.toLowerCase().includes(searchLower) ||
        balance.state?.toLowerCase().includes(searchLower) ||
        balance.trackingNo?.toLowerCase().includes(searchLower) ||
        balance.paymentTerms?.toLowerCase().includes(searchLower) ||
        balance.salesPerson?.toLowerCase().includes(searchLower) ||
        balance.masterSalePerson?.toLowerCase().includes(searchLower) ||
        balance.balanceDue?.toString().includes(searchLower) ||
        balance.overdueDays?.toString().includes(searchLower)
      );
    }

    if (selectedAging) {
      filtered = filterByAging(filtered, selectedAging);
    }

    setFilteredBalances(filtered);

    const total = Math.ceil(filtered.length / itemsPerPage);
    setTotalPages(total);

    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const pageRecords = filtered.slice(startIndex, endIndex);
    
    setDisplayBalances(pageRecords);

    console.log('📊 Filtered:', filtered.length, 'records');
    console.log('📄 Page', currentPage + 1, ':', pageRecords.length, 'records');
  };

  const filterByAging = (data, aging) => {
    switch (aging) {
      case '0-30':
        return data.filter(b => b.overdueDays >= 0 && b.overdueDays <= 30);
      case '31-60':
        return data.filter(b => b.overdueDays >= 31 && b.overdueDays <= 60);
      case '61-90':
        return data.filter(b => b.overdueDays >= 61 && b.overdueDays <= 90);
      case '90+':
        return data.filter(b => b.overdueDays > 90);
      default:
        return data;
    }
  };

  const handleSearch = () => {
    setCurrentPage(0);
  };

  const handleClearFilters = () => {
    setSearchTerm('');
    setSelectedAging('');
    setCurrentPage(0);
  };

  const handleClearSearch = () => {
    setSearchTerm('');
    setCurrentPage(0);
  };

  const handleAgingFilterChange = (value) => {
    setSelectedAging(value);
    setCurrentPage(0);
  };

  const handleExportExcel = () => {
    try {
      const dataToExport = filteredBalances.length > 0 ? filteredBalances : allBalances;
      
      const worksheet = XLSX.utils.json_to_sheet(dataToExport.map(inv => ({
        'Invoice No': inv.invoiceNo,
        'Invoice Date': inv.invoiceDate,
        'SO#': inv.soNumber,
        'SO Date': inv.soDate,
        'Customer Name': inv.customerName,
        'Contact Person': inv.contactPerson,
        'SO Customer Ref No': inv.soCustomerRefNo,
        'Invoice Total': inv.invoiceTotal,
        'Balance Due': inv.balanceDue,
        'Country': inv.country,
        'State': inv.state,
        'Overdue Days': inv.overdueDays,
        'Payment Terms': inv.paymentTerms,
        'Tracking No': inv.trackingNo,
        'Dispatch Date': inv.dispatchDate,
        'Sales Person': inv.salesPerson,
        'Master Sales Person': inv.masterSalePerson,
        'Payment Status': inv.paymentStatus
      })));
      
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Contact Person Balances');
      XLSX.writeFile(workbook, 'contact_person_balances.xlsx');
      
      console.log('✅ Exported', dataToExport.length, 'records to Excel');
    } catch (err) {
      console.error('Error exporting balances:', err);
      alert('Failed to export data');
    }
  };

  const formatCurrency = (amount) => {
    return '₹' + (amount || 0).toLocaleString('en-IN');
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { 
      day: '2-digit', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  const getOverdueBadgeClass = (days) => {
    if (days === 0) return styles.overdueBadge0;
    if (days <= 30) return styles.overdueBadge30;
    return styles.overdueBadge90;
  };

  return (
    <div className={styles.wrapper}>
      {/* <div className={styles.header}>
        <h2 className={styles.pageTitle}>My Customer Balances</h2>
        {!loading && (
          <div className={styles.recordCount}>
            {filteredBalances.length === allBalances.length 
              ? `${allBalances.length} total records`
              : `${filteredBalances.length} of ${allBalances.length} records`
            }
          </div>
        )}
      </div> */}

      <div className={styles.filtersSection}>
        <div className={styles.searchRow}>
          <div className={styles.searchInputWrapper}>
            <span className={styles.searchIcon}>🔍</span>
            <input
              type="text"
              placeholder="Search by invoice, customer, SO#, tracking number..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
              className={styles.searchInput}
            />
            {searchTerm && (
              <button onClick={handleClearSearch} className={styles.clearSearchButton} title="Clear search">
                ✕
              </button>
            )}
          </div>
          <button onClick={handleSearch} disabled={loading} className={styles.searchButton}>
            Search
          </button>
        </div>

        <div className={styles.agingFilterRow}>
          <span className={styles.agingLabel}>Filter by Overdue Days:</span>
          <div className={styles.agingButtonGroup}>
            {agingFilters.map((filter) => (
              <button
                key={filter.value}
                className={`${styles.agingButton} ${selectedAging === filter.value ? styles.agingButtonActive : ''}`}
                onClick={() => handleAgingFilterChange(filter.value)}
                disabled={loading}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>

        <div className={styles.filterRow}>
          <div className={styles.dateFilterGroup}></div>
          <div className={styles.actionButtons}>
            <button onClick={handleClearFilters} disabled={loading} className={styles.clearButton}>
              Clear All Filters
            </button>
            <button onClick={handleExportExcel} disabled={loading || allBalances.length === 0} className={styles.excelButton}>
              <span className={styles.excelIcon}>📊</span>
              Export Excel
            </button>
          </div>
        </div>
      </div>

      {(searchTerm || selectedAging) && (
        <div className={styles.activeFilters}>
          <span className={styles.activeFiltersLabel}>Active Filters:</span>
          {searchTerm && (
            <div className={styles.filterTag}>
              Search: "{searchTerm}"
              <button onClick={handleClearSearch} className={styles.removeFilterButton}>✕</button>
            </div>
          )}
          {selectedAging && (
            <div className={styles.filterTag}>
              Aging: {agingFilters.find(f => f.value === selectedAging)?.label}
              <button onClick={() => handleAgingFilterChange('')} className={styles.removeFilterButton}>✕</button>
            </div>
          )}
        </div>
      )}

      {error && (
        <div className={styles.errorMessage}>{error}</div>
      )}

      {loading && (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner} />
          <div className={styles.loadingText}>Loading your balance records...</div>
        </div>
      )}

      {!loading && (
        <div className={styles.tableContainer}>
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.th}>Invoice No.</th>
                  <th className={styles.th}>Invoice Date</th>
                  <th className={styles.th}>SO#</th>
                  <th className={styles.th}>SO Date</th>
                  <th className={styles.th}>Customer Name</th>
                  <th className={styles.th}>Contact Person</th>
                  <th className={styles.th}>SO Customer Ref No</th>
                  <th className={styles.th}>Invoice Total</th>
                  <th className={styles.th}>Balance Due</th>
                  <th className={styles.th}>Country</th>
                  <th className={styles.th}>State</th>
                  <th className={styles.th}>Overdue Days</th>
                  <th className={styles.th}>Payment Terms</th>
                  <th className={styles.th}>Tracking No</th>
                  <th className={styles.th}>Dispatch Date</th>
                  <th className={styles.th}>Sales Person</th>
                  <th className={styles.th}>Master Sales Person</th>
                  <th className={styles.th}>Payment Status</th>
                </tr>
              </thead>
              <tbody>
                {displayBalances.length > 0 ? (
                  displayBalances.map((balance, index) => (
                    <tr key={`${balance.invoiceNo}-${balance.soNumber}-${index}`} className={styles.tr}>
                      <td className={styles.td}>{balance.invoiceNo}</td>
                      <td className={styles.td}>{formatDate(balance.invoiceDate)}</td>
                      <td className={styles.td}>{balance.soNumber}</td>
                      <td className={styles.td}>{formatDate(balance.soDate)}</td>
                      <td className={styles.td}>{balance.customerName}</td>
                      <td className={styles.td}>{balance.contactPerson}</td>
                      <td className={styles.td}>{balance.soCustomerRefNo || 'N/A'}</td>
                      <td className={styles.td}>{formatCurrency(balance.invoiceTotal)}</td>
                      <td className={styles.td}>
                        <span className={`${styles.balanceDue} ${balance.balanceDue > 0 ? styles.balanceDueOverdue : styles.balanceDueNormal}`}>
                          {formatCurrency(balance.balanceDue)}
                        </span>
                      </td>
                      <td className={styles.td}>{balance.country}</td>
                      <td className={styles.td}>{balance.state}</td>
                      <td className={styles.td}>
                        <span className={`${styles.overdueBadge} ${getOverdueBadgeClass(balance.overdueDays)}`}>
                          {balance.overdueDays} days
                        </span>
                      </td>
                      <td className={styles.td}>{balance.paymentTerms}</td>
                      <td className={styles.td}>{balance.trackingNo || 'N/A'}</td>
                      <td className={styles.td}>{formatDate(balance.dispatchDate)}</td>
                      <td className={styles.td}>{balance.salesPerson}</td>
                      <td className={styles.td}>{balance.masterSalePerson || 'N/A'}</td>
                      <td className={styles.td}>
                        <span className={`${styles.paymentStatus} ${balance.paymentStatus === 'Received' ? styles.paymentStatusReceived : styles.paymentStatusPending}`}>
                          {balance.paymentStatus}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className={styles.td} colSpan="18" style={{ textAlign: 'center', padding: '40px' }}>
                      {searchTerm || selectedAging ? 'No records match your filters' : 'No records found'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {!loading && filteredBalances.length > 0 && (
        <div className={styles.paginationSection}>
          <div className={styles.paginationInfo}>
            Showing {currentPage * itemsPerPage + 1} - {Math.min((currentPage + 1) * itemsPerPage, filteredBalances.length)} of {filteredBalances.length} records
          </div>
          <div className={styles.paginationControls}>
            <button
              onClick={() => setCurrentPage(0)}
              disabled={currentPage === 0}
              className={styles.paginationButton}
            >
              First
            </button>
            <button
              onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
              disabled={currentPage === 0}
              className={styles.paginationButton}
            >
              Prev
            </button>
            <div className={styles.pageNumber}>{currentPage + 1} / {totalPages}</div>
            <button
              onClick={() => setCurrentPage(prev => Math.min(totalPages - 1, prev + 1))}
              disabled={currentPage === totalPages - 1}
              className={styles.paginationButton}
            >
              Next
            </button>
            <button
              onClick={() => setCurrentPage(totalPages - 1)}
              disabled={currentPage === totalPages - 1}
              className={styles.paginationButton}
            >
              Last
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactPersonBalanceTable;